import React, { useEffect, useState } from 'react';
import { TableBody, TableHeading, TableHeadingCol, TableRow } from '../../components/Table';
import { Button } from '@wot/components';
import TableRowitem from './components/TableRowitem';
import { useNavigate } from 'react-router-dom';
import xhr from '../../utils/fetch';
import NoResults from '../../components/NoResults';

const Curriculum = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  useEffect(() => {
    xhr({
      url: '/s/getAllSubjects',
      method: 'GET'
    })
      .then((res) => setData(res.data))
      .catch((err) => err);
  }, []);
  return (
    <div>
      <div className="py-2 flex my-4">
        <Button text={'Add New Subject'} onClick={() => navigate('/curriculum/add-subject')} />
      </div>
      <div className="w-full h-full flex flex-col gap-5 py-2 px-2">
        <table className="w-full h-full table-auto">
          <TableHeading>
            <TableRow>
              <TableHeadingCol label="DATE" />
              <TableHeadingCol label="SUBJECT CATEGORY" />
              <TableHeadingCol label="SUBJECT NAME" />
              <TableHeadingCol label="SUBJECT SLUG" />
              <TableHeadingCol label="EDIT" />
              <TableHeadingCol label="DELETE" />
            </TableRow>
          </TableHeading>
          {data.length > 0 ? (
            data.map((item, indx) => (
              <TableBody key={indx}>
                <TableRowitem data={item} />
              </TableBody>
            ))
          ) : (
            <NoResults />
          )}
        </table>
      </div>
    </div>
  );
};

export default Curriculum;
